import { Form } from 'antd'

import { formProps } from './utils'
import { CreditFields } from '../CreditFields'
import { CustomerFields } from '../PersonsFields'

export const CustomerStep = () => {
  const { priceKey } = formProps()
  const price = Form.useWatch(priceKey.name, { preserve: true })

  return (
    <>
      <CustomerFields />
      <CreditFields orderPrice={price?.amount} />
    </>
  )
}
